import { useRegisterSW } from 'virtual:pwa-register/react'
import { Button } from '@/components/ui/button'

/** "A new version is ready" - never reloads under the user while they are typing. */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Check for a new version every hour while the app is open.
      if (registration) setInterval(() => void registration.update(), 60 * 60_000)
    },
  })

  if (!needRefresh) return null
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-28 z-40 mx-auto flex max-w-md items-center gap-3 rounded-card bg-ink p-4 text-white shadow-lg lg:bottom-6"
    >
      <p className="flex-1 font-semibold">A new version of MezSites is ready.</p>
      <Button
        size="sm"
        variant="ghost"
        className="text-white hover:bg-white/10"
        onClick={() => setNeedRefresh(false)}
      >
        Later
      </Button>
      <Button size="sm" onClick={() => void updateServiceWorker(true)}>
        Update
      </Button>
    </div>
  )
}
